import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useParams } from 'react-router-dom';

import { treatmentPlanV3Actions } from '../../../../../../store';
import { isTreatmentPlanV3CrisisMutating, waitForTreatmentPlanV3CrisisIdle } from './utils';

import type { AppDispatch, RootState } from '../../../../../../store';
import type { UseTreatmentPlanV3AssessmentCrisisGuardResult } from './types';

export default function useTreatmentPlanV3AssessmentCrisisGuard(): UseTreatmentPlanV3AssessmentCrisisGuardResult {
  const dispatch = useDispatch<AppDispatch>();
  const store = useStore<RootState>();
  const { getAccessTokenSilently } = useAuth0();
  const { treatmentPlanId } = useParams<'treatmentPlanId'>();
  const crisisPage = useSelector((state: RootState) => state.treatmentPlanV3.crisisPage);
  const crisisPageError = useSelector((state: RootState) => state.treatmentPlanV3.crisisPageError);
  const isSaving = useSelector(isTreatmentPlanV3CrisisMutating);

  const refetch = useCallback(async () => {
    await waitForTreatmentPlanV3CrisisIdle(store);
    if (!treatmentPlanId) return null;
    const result = await dispatch(
      treatmentPlanV3Actions.getTreatmentPlanV3CrisisPage({
        treatmentPlanId,
        getAccessTokenSilently,
        force: true,
      }),
    );
    return treatmentPlanV3Actions.getTreatmentPlanV3CrisisPage.fulfilled.match(result)
      ? result.payload
      : null;
  }, [dispatch, getAccessTokenSilently, store, treatmentPlanId]);

  return {
    crisisPlans: crisisPage?.crisis_plans ?? [],
    crisisPageReady: crisisPage != null,
    hasCrisisLoadError: crisisPageError != null && crisisPage == null,
    isSaving,
    refetch,
  };
}
